import React from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import Modal from '../../../components/modal/modal.component'
import { Formik } from 'formik'
import { TextInput } from '../../../components/form-components/inputs.component'
import * as Yup from 'yup'

const StyledModalContainer = styled.div`
	.email-modal {
		width: 65%;
	}

	.form-modal {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		padding: 25px 0;
	}

	@media screen and (max-width: 700px) {
		.button-modal {
			margin-top: 25px;
			width: 100%;
		}

		.email-modal {
			width: 100%;
		}

		.form-modal {
			align-items: center;
			flex-direction: column;
		}
	}
`

const schemaModal = Yup.object().shape({
	modalLogin: Yup.string().required('Informe um login')
})

export default class ModalForgotPassword extends React.Component {
	render() {
		const { isOpen, onClose, onSubmit } = this.props
		return (
			<Modal
				isOpen={isOpen}
				title="Esqueci a senha"
				medium
				onClose={onClose}>
				<StyledModalContainer>
					<Formik
						validationSchema={schemaModal}
						onSubmit={onSubmit}
						initialValues={{
							modalLogin: ''
						}}
						render={props => (
							<form
								onSubmit={props.handleSubmit}
								className={'form-modal'}
								noValidate>
								<TextInput
									id="modalLogin"
									label={
										'Informe o seu e-mail, CPF ou Número Muviflex'
									}
									className={'email-modal'}
									maxLength={128}
									{...props}
								/>
								<Button
									label={'Informe e-mail para a recuperação de senha'}
									className={'button-modal'}
									primary
									type="submit">
									Enviar
								</Button>
							</form>
						)}
					/>
				</StyledModalContainer>
			</Modal>
		)
	}
}
